export const rolesEnum = {
    admin: "admin",
    adminNb: "adminnb",
    quizStep: "quizStep",
};